import { render } from "./CoBrandMidnight.vue?vue&type=template&id=3734b192&scoped=true"
import script from "./CoBrandMidnight.vue?vue&type=script&lang=js"
export * from "./CoBrandMidnight.vue?vue&type=script&lang=js"

import "./CoBrandMidnight.vue?vue&type=style&index=0&id=3734b192&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3734b192"]])

export default __exports__